// A filled circle carrying a horizontal bar — the "denied" indicator (OLIO-3170), sibling of
// CircleCheckIcon so the two sit at identical size and weight in the Referral Progress rail.
export default function CircleMinusIcon({
  width = 24,
  height = 24,
  fill = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill={fill}
        fillRule='evenodd'
        d='M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9807773,5.38056166 18.6194383,0.0192227178 12,0 Z M6,11 L18,11 L18,13 L6,13 L6,11 Z'
      />
    </svg>
  );
}
